var _path, _path2, _path3, _ellipse, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlustra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123 119.745L122.101 119.311H16.9006L16.0018 119.745V124.269V123.582C15.9658 127.201 18.95 131.002 22.9409 131.002H115.989C119.944 131.002 123 127.853 122.928 124.269V123.582L123 119.745Z",
    fill: "#2A374A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.025 126.44H22.9767C18.4825 126.44 15.1748 122.423 16.1815 118.224L25.0621 83.3681C25.8171 80.4363 28.6574 78.3008 31.8573 78.3008H107.108C110.308 78.3008 113.113 80.4001 113.904 83.3681L122.784 118.224C123.863 122.386 120.519 126.44 116.025 126.44Z",
    fill: "#FD8E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.954 98.3917C103.882 98.1743 103.811 97.8484 103.739 97.6311L76.922 12.2617H62.0437L35.191 97.5948C35.1193 97.8121 35.0476 98.1019 34.9759 98.3554C34.94 98.5365 34.7607 99.8404 34.7607 100.203C34.7607 108.932 50.3203 115.994 69.5008 115.994C88.6813 115.994 104.241 108.932 104.241 100.203C104.205 99.8767 103.99 98.609 103.954 98.3917Z",
    fill: "#FD8E00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.5007,
    cy: 12.5882,
    rx: 7.46748,
    ry: 3.58824,
    fill: "#EA7000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0477 29.877C82.0477 29.9845 82.0835 30.092 82.0835 30.2713C82.0835 33.4258 76.2912 36.0067 69.2119 36.0067C62.0967 36.0067 56.3403 33.4258 56.3403 30.2713C56.3403 30.1637 56.3403 30.0562 56.376 29.877L49.0464 52.9979H49.0821C49.0821 58.2315 58.0923 62.4973 69.1761 62.4973C80.26 62.4973 89.2701 58.2674 89.2701 52.9979H89.3058L82.0477 29.877Z",
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.882 98.2936C103.811 98.0755 103.739 97.7484 103.667 97.5303L97.2139 76.8496C96.2818 83.828 84.1998 89.3526 69.4649 89.3526C54.6941 89.3526 42.6122 83.828 41.7159 76.8496L35.191 97.5303C35.1193 97.7484 35.0476 98.0392 34.9759 98.2936C34.94 98.4753 34.7607 99.7838 34.7607 100.147C34.7607 108.907 50.3203 115.994 69.5008 115.994C88.6813 115.994 104.241 108.907 104.241 100.147C104.133 99.7838 103.918 98.5117 103.882 98.2936Z",
    fill: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustra);
export default __webpack_public_path__ + "_checkout/static/media/ilustra.8473c5a0f11dfa2590e518ab6210b960.svg";
export { ForwardRef as ReactComponent };